import { html, nothing } from 'lit';
import { ref } from 'lit/directives/ref.js';
import { BoilerplateModal } from './boilerplate_modal';

class ModalWishlistEditBoard extends BoilerplateModal {
  constructor() {
    super();
    this.fromBottom = true;
  }

  toggleModal(e) {
    super.toggleModal(e);

    if (this.form && !this.detail.name) {
      this.form.resetEmitter();
    }
  }

  renderHeader() {
    if (!this.detail) {
      return;
    }

    return html`
      ${this.detail?.name
        ? html`<h2>${this.title} ${this.detail?.name}</h2>`
        : nothing}
      <button class="_modal_close" aria-label="Close" @click=${this.toggleModal}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z" fill="black" />
        </svg>
      </button>
    `;
  }

  async connectedCallback() {
    super.connectedCallback();

    window.eventKeeper?.onEventHeard('wishlist:initialise', async (detail) => {
      this.products = await window.wishlist.getProducts();
    });

    document.addEventListener('wishlist:initialise', async () => {
      this.products = await window.wishlist.getProducts();
    });

    document.addEventListener('wishlist:remove', async () => {
      this.products = await window.wishlist.getProducts();
    });

    document.addEventListener('wishlist:update', async () => {
      this.products = await window.wishlist.getProducts();
    });
  }

  async disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener('wishlist:initialise', async () => {
      this.products = await window.wishlist.getProducts();
    });

    document.removeEventListener('wishlist:remove', async () => {
      this.products = await window.wishlist.getProducts();
    });

    document.removeEventListener('wishlist:update', async () => {
      this.products = await window.wishlist.getProducts();
    });
  }

  renderBody() {
    return html`<wishlist-edit-board-form .board=${this.detail} ${ref((el) => (this.form = el))}></wishlist-edit-board-form>`;
  }
}

window.customElements.get('modal-wishlist-edit-board') || window.customElements.define('modal-wishlist-edit-board', ModalWishlistEditBoard);
